import { render, staticRenderFns } from "./DtrManager.vue?vue&type=template&id=b501a222"
import script from "./DtrManager.vue?vue&type=script&lang=js"
export * from "./DtrManager.vue?vue&type=script&lang=js"
import style0 from "./DtrManager.vue?vue&type=style&index=0&id=b501a222&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports